import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import ZACatchLoginPageDisplay from "./ZACatchLoginPage.styled";
import axios from "axios";
import queryString from "query-string";
import { setLoginData } from "../../helpers/helpers";

import  { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import img from "../../assets/images/complete.svg";



function ZACatchLoginPage ({ t }) {
  const [errorMsg, seterrorMsg] = useState("");
  const [errsubMsg, seterrsubMsg] = useState("");
  const [errors, seterrors] = useState(false);
  const [errsub, seterrsub] = useState(false);
  const [verify_errors, setverify_errors] = useState(false);
  const [show, setshow] = useState(true);
  const [loading, setloading] = useState(false);
  const [validcode, setvalidcode] = useState(false);

  const [phonePlaceholder, setphonePlaceholder] = useState("enter_phone_number");
  const history = useHistory();
  useEffect(() => {
    fireAPI();
  } , [])



  async function fireAPI()  {


    const data = queryString.parse(window.location.search)
   //console.log(data)
    if (data.msisdn) {
      const res = await axios.get(`http://www.api.playit.mobi/api/v2/mondia-za/get-sub-details?msisdn=${data.msisdn}&plan_id=${data.plan_id}&code=${data.code}&redirect_type=login`)
        .then(res => {
          setLoginData(res.data.data.user_id, res.data.data.token, res.data.data.username, res.data.data.photo, res.data.data.operator_id, res.data.user_email, res.data.data.msisdn);
           //console.log(res.data);
          window.location.href = "/";

        }).catch(error => {
         window.location.href = "/";
        }
        )
    } else {
    window.location.href = "/";
    }
  }
  
  
  



    return (
      <ZACatchLoginPageDisplay className="">
       <div className="formPage">
          <form
         
          >
            <div className="formsLayout" style={{ minHeight: '45vh' }}>
              <div className="header">
                <Link to="/">
                  <div className="logo" />
                </Link>
              </div>
         
              <div className="center">
              <img src={img} alt="Complete" />
            </div>

            </div>
          </form>


        
        </div>

      </ZACatchLoginPageDisplay>
    );
  
}
export default withTranslation()(ZACatchLoginPage);
